/* eslint-disable promise/param-names */
const state = {
  modal_photo:{
      link_photo: '',
      sensor_photo: '',
  }
}

const getters = {
  modal_photo: state => state.modal_photo,
}

const mutations = {
    changeModalPhoto(state, payload){
        state.modal_photo = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/modal_photo.js